module.exports = __webpack_public_path__ + "img/inspiration_05@2x.5eb0e5f.jpg";